// src/App.js
import React from 'react';
import FileUpload from './components/FileUpload';

const App = () => {
    return (
        <div style={{ margin: 0, padding: 0 }}>
            <FileUpload />
        </div>
    );
};

export default App;